import React, { FC } from 'react'
import clsx from 'clsx'
import { AgentInfo } from './components'
import { IProperty } from 'src/interfaces/IProperty'

interface IAnnouncementSidebar {
  property?: IProperty
  className?: string
}

// The seller and the ways to reach them. On a desktop the aside runs the
// height of the listing column and the seller card sticks to the top of the
// window while the listing scrolls; a card taller than the window scrolls
// inside itself. The wrapper's padding (taken back by the negative margin)
// keeps the card's shadow from being cut by that scroll box.
const AnnouncementSidebar: FC<IAnnouncementSidebar> = ({ property, className }) => {
  if (!property) return null
  return (
    <aside id="announcement-contact" className={clsx('flex flex-col min-w-0', className)}>
      <div className="md:sticky md:top-0 md:max-h-screen md:overflow-y-auto md:-m-6 md:p-6">
        <AgentInfo property={property} />
      </div>
    </aside>
  )
}

export default AnnouncementSidebar
